export default "__VITE_ASSET__DTY83TIG__"